import React, { useState, useEffect } from 'react';

import { Select } from '~/componentes/CustomForm';
import {
  Container,
  ThisCard,
  ThisCalendar,
  ScrollOS,
  Status,
  ProposalStateList,
  TotalContainer,
} from './styles';
import { Chart } from '~/componentes/PieChart';

const statusMap = {
  E: 'encerrado',
  R: 'rejeitado',
  C: 'aguardandoTecnico',
  A: 'aguardandoCoordenador',
  T: 'aguardandoEncerramento',
};

function CustomBodyContent({ quantRejeitada, osRejeitada, data, anos, anoAtivo, setAnoAtivo }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [mesAtivo, setMesAtivo] = useState({ id: new Date().getMonth() + 1 });
  const [chartData, setChartData] = React.useState([]);

  useEffect(() => {
    let item = data?.length > 0 ? data[0].meses?.find(e => e?.id == mesAtivo?.id) : undefined;
    setMesAtivo(item ? item : { id: new Date().getMonth() + 1 });
  }, [data]);

  useEffect(() => {
    const totais = {
      aguardandoCoordenador: {
        color: '#dee54d',
        surname: 'Aguard. Aprovação Coord',
        horas: 0,
        minutos: 0,
      },
      aguardandoTecnico: {
        color: '#76BD3E',
        surname: 'Aguard. Aprovação Tec',
        horas: 0,
        minutos: 0,
      },
      aguardandoEncerramento: {
        color: '#6796cf',
        surname: 'Aguardando Encerramento',
        horas: 0,
        minutos: 0,
      },
      rejeitado: {
        color: '#e68282',
        surname: 'Rejeitado',
        horas: 0,
        minutos: 0,
      },
      encerrado: {
        color: '#707070',
        surname: 'Encerrado',
        horas: 0,
        minutos: 0,
      },
    };

    mesAtivo?.list?.forEach(osItem => {
      const status = statusMap[osItem.statusAprovacao];
      if (status) {
        const item = totais[status];
        item.color = osItem?.corStatusAprov ?? item.color;

        const total = osItem?.total || 0;
        const horas = Math.floor(total);
        const minutos = Math.round((total - horas) * 100);

        item.horas += horas;
        item.minutos += minutos;
      }
    });

    const formattedData = Object.entries(totais).map(([name, data]) => {
      let totalHoras = data.horas;
      let totalMinutos = data.minutos;

      const horasExtras = Math.floor(totalMinutos / 60);
      totalHoras += horasExtras;
      totalMinutos = totalMinutos % 60;
      const valorFinal = totalHoras + totalMinutos / 100;

      return {
        name,
        surname: data.surname,
        value: parseFloat(valorFinal.toFixed(2)),
        fill: data.color,
      };
    });

    setChartData(formattedData);
  }, [mesAtivo?.list]);

  return (
    <Container>
      <div className="content-os">
        {quantRejeitada > 0 && (
          <div className="alerta-rejeitado">
            <p>Você possui {quantRejeitada} ordem(ns) de serviço(s) rejeitada(s)</p>
          </div>
        )}
        <ScrollOS>
          {mesAtivo?.list?.length > 0 &&
            mesAtivo?.list?.map((thisData, i) => (
              <ThisCard
                className={linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'}
                {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
                key={thisData?.id || i}
                id={thisData?.id || i}
                index={i}
                ativo={linhaAtiva === thisData?.id ? true : false}
                corBackground={thisData?.corStatusAprov}
              >
                <div className="top">
                  <div className="content-top">
                    <div className="card-cod">
                      <p className="cod">#{thisData?.id}</p>
                    </div>
                    <div className="card-top">
                      <p className="titulo">{thisData?.titulo}</p>
                      <p className="analista">{thisData?.analista}</p>
                    </div>
                  </div>
                  <div className="info">
                    <p className="data">{thisData?.data}</p>
                    <p className="projeto">{thisData?.projeto}</p>
                    <p className="cliente">{thisData?.cliente}</p>
                  </div>
                </div>
                <div className="content-os">
                  <div className="left">
                    {/* <div className="horario">
                      {thisData?.horas?.map((thisHora, a) => (
                        <div className="item-hora" key={thisHora?.id || a}>
                          <div className="card-numero">
                            <p className="numero">{a + 1}</p>
                          </div>
                          <div className="card-hora">
                            <p className="hora">
                              {thisHora?.horaInicialMascara} - {thisHora?.horaFinalMascara}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div> */}
                    <div className="totalizadores">
                      {/* <p className="desconto">Atividades: {thisData?.horas?.length ?? 0}</p> */}
                      <p className="desconto">Desconto: {thisData?.desconto}h</p>
                      <p className="translado">Translado: {thisData?.translado}h</p>
                      <div className="card-total">
                        <p className="total">Total: {thisData?.total}h</p>
                      </div>
                    </div>
                  </div>
                  <div className="right">
                    <div className="status">
                      <p>{thisData?.descricaoStatusAprov}</p>
                      <span className="item-color"></span>
                    </div>
                  </div>
                </div>
              </ThisCard>
            ))}
        </ScrollOS>
      </div>
      <ThisCalendar>
        <div className="calendario">
          <Select
            isNumber
            list={{
              list: anos,
              value: 'id',
              label: 'id',
            }}
            name="anoAtivo"
            defaultValue={anoAtivo}
            onChange={e => {
              const v = e.currentTarget.value || 2023;

              setAnoAtivo(v);
            }}
          />
          <div className="meses">
            {data?.length > 0 &&
              data[0].meses?.map((thisData, i) => (
                <div
                  onClick={() => setMesAtivo(thisData)}
                  className={thisData?.id == mesAtivo?.id ? 'mes' : 'mes-desativo'}
                  key={thisData?.id || i}
                >
                  <p className="titulo-mes">{thisData?.sigla}</p>
                  <p className="ano">{thisData?.ano}</p>
                </div>
              ))}
          </div>
        </div>
        <TotalContainer>
          <Status>
            {chartData.map((data, index) => (
              <ProposalStateList key={data.name + index} color={data.fill}>
                <span>{data.surname}</span>
                <span>{data.value}h</span>
              </ProposalStateList>
            ))}
          </Status>
          <Chart osData={chartData} />
        </TotalContainer>
      </ThisCalendar>
    </Container>
  );
}

export default CustomBodyContent;
